import { useState } from 'react';
import { CombinationLogo } from '@/assets/logos';

type AppErrorFallbackProps = {
  errorId: string;
  onReload: () => void;
};

const AppErrorFallback = ({ errorId, onReload }: AppErrorFallbackProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(errorId).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="flex justify-content-center align-items-center h-screen w-screen p-4 text-center"
      style={{
        background: 'linear-gradient(180deg, #f4f7fb 0%, #e8eef7 100%)',
      }}
    >
      <div
        className="flex flex-column align-items-center surface-card border-round-2xl shadow-4 p-5 md:p-6"
        style={{ maxWidth: 520, width: '100%' }}
      >
        <div className="mb-4">
          <CombinationLogo />
        </div>

        <span
          className="flex align-items-center justify-content-center border-circle mb-4"
          style={{
            width: 72,
            height: 72,
            backgroundColor: 'rgba(13, 32, 108, 0.08)',
          }}
        >
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: '2rem', color: '#0d206c' }}
          />
        </span>

        <h2
          className="m-0 mb-2 text-2xl font-semibold"
          style={{ color: '#0d206c' }}
        >
          Ocurrió un error inesperado
        </h2>

        <p className="m-0 mb-4 line-height-3 text-color-secondary">
          No pudimos continuar con la operación. Si el problema persiste,
          compartí este identificador con soporte.
        </p>

        <div className="w-full mb-4 p-3 border-round-lg surface-100 text-left">
          <span className="block text-xs uppercase text-color-secondary mb-1">
            Error ID
          </span>
          <div className="flex align-items-center justify-content-between gap-2">
            <span
              className="font-medium text-sm"
              style={{ wordBreak: 'break-all' }}
            >
              {errorId}
            </span>
            <button
              type="button"
              aria-label="Copiar Error ID"
              className="p-button p-button-text p-button-sm p-button-secondary flex-shrink-0"
              onClick={handleCopy}
              title="Copiar Error ID"
            >
              <i className={`pi ${copied ? 'pi-check' : 'pi-copy'}`} />
            </button>
          </div>
        </div>

        <button
          type="button"
          className="p-button p-component justify-content-center w-full"
          onClick={onReload}
        >
          <i className="pi pi-refresh mr-2" />
          <span className="p-button-label">Recargar página</span>
        </button>
      </div>
    </div>
  );
};

export default AppErrorFallback;
